import { add } from 'date-fns';

export default function durationToSeconds(duration: Duration): number {
  return Math.floor(add(new Date(0), duration).getTime() / 1000);
}
